import { useEffect } from "react";
import { MixpanelService } from "../services/analytics/mixpanel.service";
export var useTrackScreenVisit = function (screenName) {
    useEffect(function () {
        screenName && MixpanelService.getInstance().trackScreenVisit(screenName);
    }, [screenName]);
};
